// Audit Module Types

export enum AuditAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  EXPORT = 'EXPORT',
  ACCESS_GRANTED = 'ACCESS_GRANTED',
  ACCESS_DENIED = 'ACCESS_DENIED',
}

export interface SystemAuditLog {
  id: string;
  timestamp: string;
  actorId: string;
  actorName: string;
  action: AuditAction | string;
  resource: string;
  resourceId?: string;
  details: string;
  ipAddress?: string;
}

export interface AuditFilter {
  page?: number;
  limit?: number;
  actorId?: string;
  action?: AuditAction;
  resource?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface AuditStatsItem {
  action: AuditAction;
  count: number;
}

export interface AuditExportParams {
  dateFrom: string;
  dateTo: string;
  resource?: string;
  action?: AuditAction;
}
